import React from 'react';
import c from 'classnames';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import TipHeading from '../TipHeading';
import TipText from '../TipText';
import TipButton from '../TipButton';
import { useTranslation } from 'react-i18next';
import s from './Tip.scss';

interface Props {
  heading: string;
  text: string;
  readMoreHref: string;

  className?: string;
}

/**
 * A tip that includes a heading, some text, and a read more link
 *
 * e.g.
 * ```jsx
 *  <Tip
 *    heading="How to Set and Hit Your Creative Goals"
 *    text="Views, likes, watch time, patrons, income... DeviantArt’s Matt Buc..."
 *    readMoreHref="https://www.google.com"
 *  />
 * ```
 */
const Tip: React.FC<Props> = ({ heading, text, readMoreHref, className }) => {
  const { t } = useTranslation();
  return (
    <Section className={c(s['root'], className)}>
      <TipHeading className={s['heading']}>{heading}</TipHeading>
      <TipText className={s['text']}>{text}</TipText>
      <TipButton
        href={readMoreHref}
        biData={{
          evid: BiEventType.DEFAULT,
          click_info: 'tier_knowledge_base',
        }}
      >
        {t('widgets.subscriptionsSection.tips.button.text')}
      </TipButton>
    </Section>
  );
};
Tip.displayName = 'Tip';

export default Tip;
